import React, { useState, useEffect } from "react";
import "./login.css";
import axios from "axios";
import { setUserSession, setUserPermissions, getUser } from "../../utilis/Common";
import { refreshCurrentUserPermissions } from "../../utilis/userPermissions";
import {
  buildSuperAdminOnlyPermissionFlags,
  isPermissionsSuperAdmin,
} from "../../utilis/superAdmin";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import { Button, Modal, Spinner } from "react-bootstrap";
import { QRCodeSVG } from "qrcode.react";
import { main_url } from "../../utilis/Common";
import { post_ApiManager } from "../ApiManager/ApiManager";
import LoginBackground from "./components/LoginBackground";
import BrandSection from "./components/BrandSection";
import BrandPanelClip from "./components/BrandPanelClip";
import LoginCard from "./components/LoginCard";
import RightPanelDecor from "./components/RightPanelDecor";
import MfaOtpInput from "./components/MfaOtpInput";

const Login = (props) => {
  const [email, setEmail] = useState("");
  const [resetEmail, setResetEmail] = useState("");
  const [show, setShow] = useState(false);
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState(null);
  const [passError, setPassError] = useState(null);
  const [resetEmailError, setResetEmailError] = useState(null);
  const [resetLoading, setResetLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);
  // Two-factor challenge, only used by accounts that have enrolled.
  const [mfaChallenge, setMfaChallenge] = useState(null);
  const [mfaCode, setMfaCode] = useState("");
  const [mfaError, setMfaError] = useState(null);
  const [mfaLoading, setMfaLoading] = useState(false);
  const [enrollmentChallenge, setEnrollmentChallenge] = useState(null);
  const [enrollSetup, setEnrollSetup] = useState(null);
  const [enrollCode, setEnrollCode] = useState("");
  const [enrollError, setEnrollError] = useState(null);
  const [enrollLoading, setEnrollLoading] = useState(false);
  const [enrollRecoveryCodes, setEnrollRecoveryCodes] = useState(null);
  const [recoveryCodesSaved, setRecoveryCodesSaved] = useState(false);
  const [allEntry, setAllEntry] = useState([]);
  const [ip, setIP] = useState([null]);
  const history = useNavigate();

  useEffect(() => {
    getip();
  }, []);

  const getip = async () => {
    fetch("https://geolocation-db.com/json/")
      .then((res) => res.json())
      .then((data) => setIP(data))
      .catch((e) => console.log(e));
  };

  const handleValidation = (e) => {
    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    setEmailError(null);
    setPassError(null);
    if (!email) {
      setEmailError("Please Enter Email");
      return false;
    } else if (!pattern.test(email)) {
      setEmailError("Please Enter Correct Email");
      return false;
    } else if (!password) {
      setPassError("Please Enter Password");
      return false;
    } else {
      return true;
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const newEntry = { email, password };
    if (handleValidation()) {
      setAllEntry([...allEntry, newEntry]);
      console.log(allEntry);
      handleLogin();
    }
  };

  const completeLogin = () => {
    history("/dashboard");
    window.location.reload(false);
  };

  const establishSession = async (token, user, permissions) => {
    setUserSession(token, user);
    try {
      await refreshCurrentUserPermissions();
    } catch {
      if (isPermissionsSuperAdmin()) {
        setUserPermissions({ permissions: buildSuperAdminOnlyPermissionFlags() });
      } else {
        setUserPermissions(permissions || {});
      }
    }
    if (localStorage.getItem("token")) {
      const sessionUser = getUser();
      props.socket?.emit(
        "newUser",
        sessionUser["id"],
        sessionUser["profile_image_url"],
      );
    }
  };

  const handleLogin = () => {
    setLoading(true);
    const data = {
      email: email,
      password: password,
      loading: true,
      ip: ip?.IPv4 || null,
    };
    try {
      axios.post(main_url() + "/api/v1/user-login", data).then((res) => {
        console.log("res", res);
        // The password was right but the account has a second factor. This comes
        // back with status true and no token, so it has to be handled before the
        // success branch or we would store an undefined session.
        if (res.data.mfa_required === true) {
          setLoading(false);
          setMfaChallenge(res.data.challenge);
          setMfaCode("");
          setMfaError(null);
          return;
        }

        if (
          res.data.mfa_enrollment_required === true ||
          res.data.code === "2FA_ENROLLMENT_REQUIRED"
        ) {
          setLoading(false);
          setEnrollmentChallenge(res.data.enrollment_challenge);
          setEnrollCode("");
          setEnrollError(null);
          setEnrollRecoveryCodes(null);
          beginEnrollment(res.data.enrollment_challenge);
          return;
        }

        if (res.data.status === true) {
          establishSession(
            res.data.token,
            res.data.user,
            res.data.permissions,
          ).finally(() => {
            setLoading(false);
            setLoginSuccess(true);
          });
        } else {
          console.log("false status", res.data.message);
          setLoading(false);
          setLoginSuccess(false);
          swal(res.data.message, { icon: "error" });
        }
      }).catch((err) => {
        setLoading(false);
        setLoginSuccess(false);
        const data = err?.response?.data;
        swal(data?.message || data?.error || "Something went wrong!", { icon: "error" });
      });
    } catch (e) {
      setLoading(false);
      setLoginSuccess(false);
      console.log(e);
      swal("Oops!", "Something went wrong!", "error");
    }
  };

  // Each challenge is single use, so a failed code means starting again from the
  // password. Closing the prompt therefore discards the challenge entirely.
  const cancelMfa = () => {
    setMfaChallenge(null);
    setMfaCode("");
    setMfaError(null);
    setMfaLoading(false);
  };

  const cancelEnrollment = () => {
    setEnrollmentChallenge(null);
    setEnrollSetup(null);
    setEnrollCode("");
    setEnrollError(null);
    setEnrollLoading(false);
    setEnrollRecoveryCodes(null);
  };

  const beginEnrollment = (challenge, restart = false) => {
    if (!challenge) return;
    setEnrollLoading(true);
    setEnrollError(null);
    axios
      .post(main_url() + "/api/v1/2fa/enroll", {
        enrollment_challenge: challenge,
        restart: restart,
      })
      .then((res) => {
        setEnrollLoading(false);
        if (res.data?.status && res.data?.data) {
          setEnrollSetup(res.data.data);
        } else {
          setEnrollError(res.data?.message || "Could not start 2FA setup.");
        }
      })
      .catch((err) => {
        setEnrollLoading(false);
        if (err?.response?.status === 401) {
          cancelEnrollment();
          swal("Session expired", "Please sign in again.", "error");
          return;
        }
        setEnrollError(
          err?.response?.data?.message || "Could not start 2FA setup."
        );
      });
  };

  const submitEnrollment = () => {
    if (enrollLoading || !enrollmentChallenge) return;
    const code = enrollCode.replace(/\D/g, "");
    if (!code) {
      setEnrollError("Enter the 6-digit code from your authenticator app.");
      return;
    }
    setEnrollLoading(true);
    setEnrollError(null);
    axios
      .post(main_url() + "/api/v1/2fa/confirm", {
        enrollment_challenge: enrollmentChallenge,
        code,
      })
      .then((res) => {
        setEnrollLoading(false);
        if (res.data?.status === true && res.data?.token) {
          const codes = res.data?.data?.recovery_codes || [];
          establishSession(
            res.data.token,
            res.data.user,
            res.data.permissions,
          ).finally(() => {
            setEnrollmentChallenge(null);
          });
          setEnrollSetup(null);
          setRecoveryCodesSaved(false);
          if (codes.length > 0) {
            setEnrollRecoveryCodes(codes);
            return;
          }
          setLoginSuccess(true);
          return;
        }
        setEnrollError(res.data?.message || "That code is not valid.");
      })
      .catch((err) => {
        setEnrollLoading(false);
        if (err?.response?.status === 401) {
          cancelEnrollment();
          swal("Session expired", "Please sign in again.", "error");
          return;
        }
        setEnrollError(
          err?.response?.data?.message || "That code is not valid."
        );
      });
  };

  const submitMfa = () => {
    if (mfaLoading) return;

    const code = mfaCode.trim();
    if (!code) {
      setMfaError("Enter the code from your authenticator app.");
      return;
    }

    setMfaLoading(true);
    setMfaError(null);

    axios
      .post(main_url() + "/api/v1/2fa/challenge", {
        challenge: mfaChallenge,
        code: code,
      })
      .then((res) => {
        setMfaLoading(false);

        if (res.data.status === true && res.data.token) {
          setMfaChallenge(null);
          establishSession(
            res.data.token,
            res.data.user,
            res.data.permissions,
          ).finally(() => {
            setLoginSuccess(true);
          });
          return;
        }

        setMfaError(res.data.message || "That code is not valid.");
      })
      .catch((err) => {
        setMfaLoading(false);
        const status = err?.response?.status;

        // 401 means the challenge itself expired or was already spent, so there
        // is nothing left to retry against — send them back to the password.
        if (status === 401) {
          cancelMfa();
          swal(
            "Session expired",
            err?.response?.data?.message || "Please sign in again.",
            "error"
          );
          return;
        }

        setMfaError(
          err?.response?.data?.message || "That code is not valid."
        );
        setMfaCode("");
      });
  };

  // Always reset the form state on open and on close, so a previous attempt's
  // email or validation error never carries into the next one.
  const handleModal = () => {
    setResetEmail("");
    setResetEmailError(null);
    setResetLoading(false);
    setShow(!show);
  };

  const checkEmail = () => {
    if (resetLoading) return;

    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    setResetEmailError(null);
    if (!resetEmail) {
      setResetEmailError("Please enter email");
      return false;
    } else if (!pattern.test(resetEmail)) {
      setResetEmailError("Please enter correct email");
      return false;
    } else {
      setResetLoading(true);
      let url = "verifyEmail";
      var data = { resetEmail: resetEmail };
      post_ApiManager(
        data,
        url,
        (res) => {
          setResetLoading(false);
          swal("Check your email", res.data.message, "success").then(() => {
            handleModal();
          });
        },
        (err) => {
          setResetLoading(false);
          const status = err?.response?.status;

          // 404 = address not registered, 422 = failed validation, 429 = too many
          // requests. All belong inline under the field rather than in an alert
          // they have to dismiss.
          if (status === 404 || status === 422 || status === 400 || status === 429) {
            setResetEmailError(
              err?.response?.data?.error || "Please enter correct email"
            );
            return;
          }

          swal("Oops!", "Something went wrong. Please try again.", "error");
        }
      );
    }
  };

  return (
    <div className="login-page">
      <BrandPanelClip />
      <aside className="login-brand-panel">
        <LoginBackground />
        <BrandSection />
      </aside>

      <main className="login-right-panel">
        <RightPanelDecor />
        <div className="login-right-glow" />
        <div className="login-right-inner">
          <LoginCard
            email={email}
            setEmail={setEmail}
            password={password}
            setPassword={setPassword}
            emailError={emailError}
            passError={passError}
            loading={loading}
            loginSuccess={loginSuccess}
            onSubmit={onSubmit}
            onForgotPassword={handleModal}
            onLoginVideoEnd={completeLogin}
            ip={ip}
          />
        </div>
      </main>

      <Modal
        className="login-reset-modal p-modal-content"
        backdropClassName="login-reset-backdrop"
        show={show}
        onHide={handleModal}
        centered
      >
        <Modal.Header className="modal-header" closeButton>
          <div className="col-11 text-center font-f-sans text-white">
            Reset Password
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="form-group col-10 ml-lg-4">
              <label className="profile-label">Email:</label>
              <input
                name="resetEmail"
                type="email"
                value={resetEmail}
                disabled={resetLoading}
                onChange={(e) => setResetEmail(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") checkEmail();
                }}
                placeholder="Please enter your email"
                className="card-text form-control acc-form col-11"
                autoFocus
              />
              {resetEmailError && (
                <>
                  <small className="error" style={{ color: "red" }}>
                    {resetEmailError}
                  </small>
                  <br />
                </>
              )}
              <br />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModal} disabled={resetLoading}>
            Cancel
          </Button>
          <Button onClick={checkEmail} disabled={resetLoading}>
            {resetLoading ? "Sending..." : "Reset"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        className="login-reset-modal p-modal-content"
        backdropClassName="login-reset-backdrop"
        show={enrollmentChallenge !== null || enrollRecoveryCodes !== null}
        onHide={() => {
          if (!enrollRecoveryCodes) cancelEnrollment();
        }}
        backdrop={enrollRecoveryCodes ? "static" : true}
        keyboard={!enrollRecoveryCodes}
        centered
        size="lg"
      >
        <Modal.Header className="modal-header" closeButton={!enrollRecoveryCodes}>
          <div className="col-11 text-center font-f-sans text-white">
            {enrollRecoveryCodes ? "Recovery codes" : "Set up 2FA"}
          </div>
        </Modal.Header>
        <Modal.Body>
          {enrollRecoveryCodes ? (
            <div>
              <p className="small text-muted mb-3">
                Copy and store these codes. Each works once.
              </p>
              <div className="d-flex justify-content-end mb-2">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => {
                    navigator.clipboard.writeText(enrollRecoveryCodes.join("\n"));
                    setRecoveryCodesSaved(true);
                  }}
                >
                  Copy all
                </Button>
              </div>
              <div className="row g-2">
                {enrollRecoveryCodes.map((c) => (
                  <div key={c} className="col-6 col-md-4">
                    <div className="text-center font-monospace small border rounded py-2 bg-light">
                      {c}
                    </div>
                  </div>
                ))}
              </div>
              <label className="d-flex align-items-center gap-2 mt-3 small">
                <input
                  type="checkbox"
                  checked={recoveryCodesSaved}
                  onChange={(e) => setRecoveryCodesSaved(e.target.checked)}
                />
                I have saved these codes
              </label>
            </div>
          ) : (
            <div className="row g-3">
              <div className="col-md-5 text-center">
                {enrollLoading && !enrollSetup ? (
                  <Spinner animation="border" />
                ) : enrollSetup?.otpauth_url ? (
                  <div className="bg-white d-inline-block p-2 rounded">
                    <QRCodeSVG
                      value={enrollSetup.otpauth_url}
                      size={180}
                      level="M"
                      includeMargin
                    />
                  </div>
                ) : null}
                <p className="small text-muted mt-2 px-2">Scan with your authenticator app</p>
              </div>
              <div className="col-md-7">
                {enrollSetup?.secret && (
                  <p className="small font-monospace text-break">
                    Manual key: {enrollSetup.secret}
                  </p>
                )}
                <label className="profile-label">Verification code</label>
                <input
                  type="text"
                  inputMode="numeric"
                  autoComplete="one-time-code"
                  maxLength={6}
                  value={enrollCode}
                  disabled={enrollLoading}
                  onChange={(e) =>
                    setEnrollCode(e.target.value.replace(/\D/g, "").slice(0, 6))
                  }
                  onKeyDown={(e) => e.key === "Enter" && submitEnrollment()}
                  className="form-control acc-form mb-2"
                  placeholder="000000"
                />
                {enrollError && (
                  <small className="error" style={{ color: "red" }}>
                    {enrollError}
                  </small>
                )}
                {enrollSetup?.reuse_existing_authenticator && (
                  <Button
                    variant="link"
                    size="sm"
                    className="p-0 mt-2"
                    disabled={enrollLoading}
                    onClick={() =>
                      beginEnrollment(enrollmentChallenge, true)
                    }
                  >
                    Set up on a new device (new secret)
                  </Button>
                )}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {enrollRecoveryCodes ? (
            <Button
              disabled={!recoveryCodesSaved}
              onClick={() => {
                setEnrollRecoveryCodes(null);
                setLoginSuccess(true);
              }}
            >
              Continue
            </Button>
          ) : (
            <>
              <Button variant="secondary" onClick={cancelEnrollment} disabled={enrollLoading}>
                Cancel
              </Button>
              <Button onClick={submitEnrollment} disabled={enrollLoading || !enrollSetup}>
                {enrollLoading ? "Verifying…" : "Confirm & sign in"}
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        className="login-reset-modal login-mfa-modal p-modal-content"
        backdropClassName="login-reset-backdrop"
        show={mfaChallenge !== null}
        onHide={cancelMfa}
        centered
        dialogClassName="login-mfa-modal__dialog"
      >
        <Modal.Header className="modal-header login-mfa-modal__header" closeButton>
          <div className="login-mfa-modal__header-inner">
            <span className="login-mfa-modal__header-icon" aria-hidden="true">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3z"
                  stroke="currentColor"
                  strokeWidth="1.75"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.5 12.5l2 2 3.5-4"
                  stroke="currentColor"
                  strokeWidth="1.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <span className="login-mfa-modal__header-title font-f-sans">
              Two-Factor Authentication
            </span>
          </div>
        </Modal.Header>
        <Modal.Body className="login-mfa-modal__body">
          <p className="login-mfa-modal__lead">
            Enter the 6-digit code from your authenticator app to continue.
          </p>
          <MfaOtpInput
            value={mfaCode}
            onChange={setMfaCode}
            disabled={mfaLoading}
            onEnter={submitMfa}
          />
          {mfaError ? (
            <p className="login-mfa-modal__error" role="alert">
              {mfaError}
            </p>
          ) : null}
        </Modal.Body>
        <Modal.Footer className="login-mfa-modal__footer">
          <Button
            variant="light"
            className="login-mfa-modal__btn login-mfa-modal__btn--cancel"
            onClick={cancelMfa}
            disabled={mfaLoading}
          >
            Cancel
          </Button>
          <Button
            className="login-mfa-modal__btn login-mfa-modal__btn--verify"
            onClick={submitMfa}
            disabled={mfaLoading}
          >
            {mfaLoading ? "Verifying…" : "Verify & sign in"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Login;
